var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Dialog',{ref:"p"},[_c('div',{staticClass:"dialog-content"},[_c('div',{staticClass:"icon"},[_c('img',{attrs:{"src":"//cdn.hongbaoxd.com/images/2145639abc8f1db82c7ed954ea95464a.png","alt":""}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }